import { render, staticRenderFns } from "./NotificationListGrid.vue?vue&type=template&id=bcd58270"
import script from "./NotificationListGrid.vue?vue&type=script&lang=js"
export * from "./NotificationListGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports